import React from 'react';

interface PlaceholderPortraitProps {
  label: string;
  className?: string;
  imageUrl?: string;
}

const PlaceholderPortrait: React.FC<PlaceholderPortraitProps> = ({ label, className = '', imageUrl }) => (
  <div
    className={`w-full h-full bg-transparent border-transparent rounded-lg flex items-center justify-center text-sm text-gray-300 overflow-hidden ${className}`}
  >
    {imageUrl ? (
      <img src={imageUrl} alt={label} className="w-full h-full object-cover" />
    ) : (
      <span>{label}</span>
    )}
  </div>
);

export default PlaceholderPortrait;
